import { RoleType } from '@tribeplatform/gql-client/types'
import { useRouter } from '@tribeplatform/react-sdk'
import {
  useAuthToken,
  useSpaceUtil,
  SystemSpaceSlug,
} from '@tribeplatform/react-sdk/hooks'

export const useLogin = () => {
  const { data: authToken } = useAuthToken()
  const isGuest =
    !authToken?.role?.type || authToken?.role?.type === RoleType.guest
  const { push, replace } = useRouter()
  const { generatePath } = useSpaceUtil()

  const showLogin = (replacePath = false) => {
    if (!isGuest) {
      return false
    }
    const path = generatePath(
      SystemSpaceSlug.LOGIN,
      null,
      window.location?.pathname
        ? { redirect: encodeURIComponent(window.location.pathname) }
        : null,
    )
    if (replacePath) {
      replace(path)
    } else {
      push(path)
    }
  }

  const isLoggedIn = !isGuest

  return {
    showLogin,
    isLoggedIn,
  }
}
